import Const from 'constants';

const initialState = {
    data: {},
    isOnlyInCorrelationStackingUsed(playerId) {
        return this.data.hasOwnProperty(playerId) && this.data[playerId];
    },
    getRestrictedPlayerIds() {
        return Object.keys(this.data).map(Number);
    },
    all() {
        return {...this.data};
    },
};

export default function players(state = {...initialState}, action) {
    switch (action.type) {
        case Const.CORRELATION_STACKING_RESTRICT_PLAYERS:
            state = {...state};
            Object.keys(action.items).map((playerId) => {
                if (Boolean(action.items[playerId])) {
                    state.data[playerId] = true;
                } else if (state.data.hasOwnProperty(playerId)) {
                    delete state.data[playerId];
                }
            });
            return state;

        case Const.LOCKING_SET_PLAYERS:
            state = {...state};
            Object.values(action.items).map((modes) => {
                Object.keys(modes).map((playerId) => {
                    if (Boolean(modes[playerId]) && state.data.hasOwnProperty(playerId)) {
                        delete state.data[playerId];
                    }
                });
            });
            return state;

        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return {...initialState, data: {}};
        default:
            return state;
    }
}
